// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cjWvWEDXei9MyIrtcjyd{padding:4px 0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/ui/ManualConversationAssignment/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA","sourcesContent":[".sentimentContainer {\n  padding: 4px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sentimentContainer": `cjWvWEDXei9MyIrtcjyd`
};
export default ___CSS_LOADER_EXPORT___;
